"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PocCloudTabs from "@/components/pageTabs/pocCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import BenefitsComponent from "./components/benefits";

const PhysicalLabsPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout showContactForm>
        <PocCloudTabs />
        <Intro />
        <FeaturesComponent />
        <BenefitsComponent />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default PhysicalLabsPage;
